import { useState } from "react";
import useUpdateGlobalPosition from "./useUpdateGlobalPosition.js";
import useUpdateLeftPosition from "./useUpdateLeftPosition.js";
import useUpdateTopPosition from "./useUpdateTopPosition.js";

const useUpdateSizeValues = () => {
  const updateGlobalPosition = useUpdateGlobalPosition();
  const updateLeftPosition = useUpdateLeftPosition();
  const updateTopPosition = useUpdateTopPosition();

  const updateSizeValues = (containers,id, width, height) => {
    if (!containers.metaData) return;
    containers.metaData.map((container,index) => {
      if (id == container.id) {
        
        container.styles.width = {...container.styles.width, value : width};
        container.styles.height = {...container.styles.height, value : height};
        if (containers.type == "ListView"){
          updateTopPosition(containers, container.styles.top.value, height, index +1);
          updateGlobalPosition(containers);
        }
        if (containers.type == "SplitListView"){
          updateLeftPosition(containers, container.styles.left.value, width, height, index +1);
          updateGlobalPosition(containers);
        }
        return;
      }
      else
      updateSizeValues(container,id, width, height);
    });
  };

  /*
    const updateTopPosition = (containers, top, height, nextIndex) => {
    var previousTop = top;
    var previousHeight = height;
    containers.metaData.slice(nextIndex).map(container => {
      container.styles.top = previousTop + parseInt(previousHeight.slice(0,-2));
      previousTop = container.styles.top;
      previousHeight = container.styles.height;
      
    });
  }

  const updateLeftPosition = (containers, left, width, height, nextIndex) => {
    var previousLeft = left;
    var previousWidth = width;
    containers.metaData.slice(nextIndex).map(container => {
      container.styles.left = previousLeft + parseInt(previousWidth.slice(0,-2));
      previousLeft = container.styles.left;
      previousWidth = container.styles.width;
      
    });
    containers.metaData.map(container => {
      container.styles.height = height;
    });
  }*/

  return updateSizeValues;
};

export default useUpdateSizeValues;
